// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var Context_I18n = require("./Context_I18n.bs.js");
var Context_Config = require("./Context_Config.bs.js");

function Make(B) {
  var initialState = B.initialState;
  var initialFullState = {
    status: /* NotInitialized */2,
    state: initialState
  };
  var ctx = React.createContext([
        initialFullState,
        (function (param) {
            
          })
      ]);
  var use = function (param) {
    var match = React.useContext(ctx);
    var state = match[0];
    return [
            state.state,
            match[1],
            state.status
          ];
  };
  var getState = function (param) {
    return use(undefined)[0];
  };
  var getStateAndDispatch = function (param) {
    var match = use(undefined);
    return [
            match[0],
            match[1]
          ];
  };
  var make = function (status, state) {
    return {
            status: status,
            state: state
          };
  };
  var provider = ctx.Provider;
  var Context$Make$Provider = function (Props) {
    var value = Props.value;
    var children = Props.children;
    return React.createElement(provider, {
                value: value,
                children: children
              });
  };
  return {
          initialState: initialState,
          getState: getState,
          getStateAndDispatch: getStateAndDispatch,
          make: make,
          Provider: {
            make: Context$Make$Provider
          }
        };
}

var initialFullState = {
  status: /* NotInitialized */2,
  state: Context_Config.initialState
};

var ctx = React.createContext([
      initialFullState,
      (function (param) {
          
        })
    ]);

function use(param) {
  var match = React.useContext(ctx);
  var state = match[0];
  return [
          state.state,
          match[1],
          state.status
        ];
}

function getState(param) {
  return use(undefined)[0];
}

function getStateAndDispatch(param) {
  var match = use(undefined);
  return [
          match[0],
          match[1]
        ];
}

function make(status, state) {
  return {
          status: status,
          state: state
        };
}

var provider = ctx.Provider;

function Context$Make$Provider(Props) {
  var value = Props.value;
  var children = Props.children;
  return React.createElement(provider, {
              value: value,
              children: children
            });
}

var Context_Provider = {
  make: Context$Make$Provider
};

var Context = {
  initialState: Context_Config.initialState,
  getState: getState,
  getStateAndDispatch: getStateAndDispatch,
  make: make,
  Provider: Context_Provider
};

function getFeatureFlippingStatus(requestedFeature) {
  var state = getState(undefined);
  return Context_Config.Helpers.getFeatureFlippingStatus(requestedFeature, state);
}

var Config_Provider = Context_Provider;

var Config = {
  Context: Context,
  Helpers: undefined,
  getFeatureFlippingStatus: getFeatureFlippingStatus,
  initialState: Context_Config.initialState,
  getState: getState,
  getStateAndDispatch: getStateAndDispatch,
  make: make,
  Provider: Config_Provider
};

var initialFullState$1 = {
  status: /* NotInitialized */2,
  state: Context_I18n.initialState
};

var ctx$1 = React.createContext([
      initialFullState$1,
      (function (param) {
          
        })
    ]);

function use$1(param) {
  var match = React.useContext(ctx$1);
  var state = match[0];
  return [
          state.state,
          match[1],
          state.status
        ];
}

function getState$1(param) {
  return use$1(undefined)[0];
}

function getStateAndDispatch$1(param) {
  var match = use$1(undefined);
  return [
          match[0],
          match[1]
        ];
}

function make$1(status, state) {
  return {
          status: status,
          state: state
        };
}

var provider$1 = ctx$1.Provider;

function Context$Make$Provider$1(Props) {
  var value = Props.value;
  var children = Props.children;
  return React.createElement(provider$1, {
              value: value,
              children: children
            });
}

var I18n_Provider = {
  make: Context$Make$Provider$1
};

var I18n = {
  initialState: Context_I18n.initialState,
  getState: getState$1,
  getStateAndDispatch: getStateAndDispatch$1,
  make: make$1,
  Provider: I18n_Provider
};

exports.Make = Make;
exports.Config = Config;
exports.I18n = I18n;
/* ctx Not a pure module */
